import { render } from "./ServicosLandingPage.vue?vue&type=template&id=152f7863&scoped=true"
import script from "./ServicosLandingPage.vue?vue&type=script&lang=js"
export * from "./ServicosLandingPage.vue?vue&type=script&lang=js"

import "./ServicosLandingPage.vue?vue&type=style&index=0&id=152f7863&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-152f7863"]])

export default __exports__